import { Navigate, useParams } from "react-router-dom";
import { ArticleLayout } from "@/components/ArticleLayout";
import { getResearchArticle, researchArticles } from "@/content/researchArticles";

export default function ResearchArticlePage() {
  const { slug } = useParams();
  const article = getResearchArticle(slug);
  if (!article) return <Navigate to="/research" replace />;
  const index = researchArticles.findIndex((entry) => entry.slug === slug);
  const next = index > 0 ? researchArticles[index - 1] : null;
  const previous = index < researchArticles.length - 1 ? researchArticles[index + 1] : null;
  return <ArticleLayout article={article} previous={previous} next={next} />;
}